import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import aiModule from "@kubdee/module-ai";

export default createModuleLayout({
  moduleId: MODULES.AI,
  moduleConfig: aiModule,
});
